import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';

registerBlockType('rielstonenew/gen-question', {
  edit: Edit,
  save: () => null,
});
